import {CustomWiggle} from "gsap/dist/CustomWiggle";

/**
 * Created by Jerker Nord on 2022-10-28.
 */

export class BenjiKIVStatics {

    private static _isSpinAborted:boolean = false;

    public static DEAD_ANTICIPATION_DELAY_NORMAL:number = 0.5;
    public static DEAD_ANTICIPATION_DELAY_FAST:number = 0.25;
    public static DICE_ANTICIPATION_DELAY_NORMAL:number = 0.5;
    public static DICE_ANTICIPATION_DELAY_FAST:number = 0.25;
    public static DICE_ANTICIPATION_DELAY_LUCKY_DRAW:number = 1.25;

    public static defaultGameAreaSize:number[] = [3, 3, 3, 3, 3];
    public static symbolWidth:number = 144;
    public static symbolHeight:number = 168;
    public static stepDuration:number = 0.08;


    public static spinStepDurationNormal:number = 0.045;
    public static spinStartDurationNormal:number = 0.260;
    public static reelStopDelayNormal:number[] = [0, 0.41, 0.40, 0.38, 0.38];
    public static reelStopDelayBadOutcomeNormal:number[] = [0, 0.41, 0.40, 0.30, 0.05];
    public static BLUR_DELAY_SPIN_START_NORMAL:number = 0.02;
    public static BLUR_DURATION_SPIN_START_NORMAL:number = 0.20;

    public static spinStepDurationFast:number = 0.025;
    public static spinStartDurationFast:number = 0.120;
    public static reelStopDelayFastSpin:number[] = [0, 0.21, 0.20, 0.18, 0.18];
    public static reelStopDelayBadOutcomeFast:number[] = [0, 0.21, 0.20, 0.08, 0.05];
    public static BLUR_DELAY_SPIN_START_FAST:number = 0.01;
    public static BLUR_DURATION_SPIN_START_FAST:number = 0.07;


    public static X_SPLIT_ATTENTION_REEL_DELAY:number = 0.6;
    public static BLUR_DELAY_SPIN_STOP:number = 0.02;
    public static BLUR_DURATION_SPIN_STOP:number = 0.02;
    public static betweenReelsStartDelay:number = 0.04;
    public static reelStopBounceDuration:number = 0.06;
    public static stepSize:number = 168;
    public static MAIN_REELS_VIEW_POSITION:PIXI.Point = new PIXI.Point(70, -70);
    public static MAIN_REELS_VIEW_MASK_POSITION:PIXI.Point = new PIXI.Point(-72, 252);
    public static SYMBOLS:string[] = ["L1", "L2", "L3", "L4", "L5"];
    public static STACKED_SYMBOLS:string[] = ["M1", "M2", "M3", "W", "S"]
    public static STACKED_SYMBOLS_NO_WILD:string[] = ["M1", "M2", "M3", "S"];
    public static SCATTER_OVERLAY_RANDOM_POSITIONS_NORMAL:number = 4;
    public static SCATTER_OVERLAY_RANDOM_POSITIONS_FAST:number = 2;
    public static SCATTER_OVERLAY_RANDOM_POSITIONS_FS:number = 2;

    public static reelPositions:PIXI.Point[] = [
        new PIXI.Point(BenjiKIVStatics.symbolWidth * 0, 0 - BenjiKIVStatics.symbolHeight),
        new PIXI.Point(BenjiKIVStatics.symbolWidth * 1, 0 - BenjiKIVStatics.symbolHeight),
        new PIXI.Point(BenjiKIVStatics.symbolWidth * 2, 0 - BenjiKIVStatics.symbolHeight),
        new PIXI.Point(BenjiKIVStatics.symbolWidth * 3, 0 - BenjiKIVStatics.symbolHeight),
        new PIXI.Point(BenjiKIVStatics.symbolWidth * 4, 0 - BenjiKIVStatics.symbolHeight),
        new PIXI.Point(BenjiKIVStatics.symbolWidth * 5, 0 - BenjiKIVStatics.symbolHeight)
    ];

    static get isSpinAborted():boolean {
        return this._isSpinAborted;
    }

    static set isSpinAborted(value:boolean) {
        this._isSpinAborted = value;
    }
}